import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Check if user is authenticated using the same key set in Login.js/App.js
  const isAuthenticated = localStorage.getItem("fleet_authenticated") === "true";
  const user = localStorage.getItem("fleet_user");

  // If there's no auth flag or no user data, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
